class StorefrontResource {
  public isStorefront(): boolean {
    return !!import.meta.env.VITE_CONFIG_BASE_DOMAIN;
  }
}

export default new StorefrontResource();
